import React, { useEffect, useRef, useState } from 'react';
import { Button, Dropdown, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import {
  allBranchDetail,
  allCounselorDetail,
  allDoctorDetail,
  allDoctorSearchDetail,
  allProblemDetail,
  allProblemSearchDetail,
  leadCreate,
  patientData,
  patientSearchData,
  searchAllCounselorDetail,
} from '../../../redux/actions/Files.action';
import {
  getAdmin,
  getBranch,
  getCounselor,
  getDoctor,
  getProblem,
  searchAdmin,
  searchCounselor,
  searchDoctor,
} from '../../../redux/actions/Master.action';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { getSetting } from '../../../redux/actions/Setting.action';

const CreateModal = ({ show, toggle, limits, searchDefault1 }) => {
  const [mainPage, setMainPage] = useState(1);
  const dispatch = useDispatch();
  const createFile = useSelector((state) => state.files);
  const masterData = useSelector((state) => state.master);
  const [doctorData, setDoctorData] = useState(false);
  const [doctorData1, setDoctorData1] = useState(false);
  const [doctorData2, setDoctorData2] = useState(false);
  const [problemData, setProblemData] = useState(false);
  const setting = useSelector((state) => state.setting);

  const dropdownRef = useRef(null);
  const createBy = localStorage.getItem('type');
  const [time, setTime] = useState({
    from: '',
    to: '',
  });
  const [values, setValues] = useState({
    firstName: '',
    middleName: '',
    lastName: '',
    gender: '',
    dateOfBirth: '',
    nationality: '',
    country: '',
    state: '',
    city: '',
    area: '',
    address: '',
    pincode: '',
    phoneNumber: '',
    email: '',
    occupation: '',
    bloodGroup: '',
    photo: null,
    branch: '',
    leadReceived: '',
    problem: '',
    leadStatus: '',
    leadFrom: '',
    campaign: { cname: '', description: '' },
    reference: [{ personDetail: '', doctorDetail: '' }],
    remark: '',
    nextFollowUpDate: '',
    selectedReference: '',
    from: '',
    to: '',
    doctorName: '',
    doctorEmail: '',
    counselorAssign: '',
    leadFollowUpRemark: '',
    createdBy: createBy,
    referralCode: ''
  });

  const initialValues = {
    firstName: '',
    lastName: '',
    // gender: '',
    phoneNumber: '',
    // problem: '',
  };

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required('First Name is required'),
    lastName: Yup.string().required('Last Name is required'),
    // gender: Yup.string().required('Gender is required'),
    phoneNumber: Yup.string().required('Phone Number is required'),
    // problem: Yup.string().required('Problem is required'),
  });

  useEffect(() => {
    dispatch(getSetting())
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDoctorData(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleFileChange = (event, setFieldValue) => {
    const file = event.currentTarget.files[0];
    setFieldValue('photo', file);
  };

  const handleLead = (e) => {
    const { name, value } = e.target;

    if (name === 'from' || name === 'to') {
      setTime((prevState) => ({
        ...prevState,
        [name]: value,
      }));
      const formattedTime = formatTime12Hour(value);
      setValues((prevState) => ({
        ...prevState,
        [name]: formattedTime,
      }));
    } else {
      setValues((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  console.log("setting", setting);


  const formatTime12Hour = (time) => {
    const [hours, minutes] = time.split(':');
    const period = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12;
    return `${formattedHours}:${minutes} ${period}`;
  };

  const [selectedOption, setSelectedOption] = useState('');
  const [selectedDoctor, setSelectedDoctor] = useState('');
  const [selectedCounselor, setSelectedCounselor] = useState('');
  const [selectedProblem, setSelectedProblem] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [searchDefault, setSearchDefault] = useState({
    page: '',
    search: '',
  });
  const [searchType, setSearchType] = useState('doctor');

  const selectDoctor = (doctorName, doctorEmail) => {
    setSelectedDoctor(doctorName);
    setDoctorData1(false);
    setSearchQuery('');
    setSearchDefault({ page: '', search: '' });
    dispatch(allDoctorSearchDetail('', '1'));

    setValues((prevValues) => ({
      ...prevValues,
      doctorName: doctorName,
      doctorEmail: doctorEmail
    }));
  };

  const selectCounselor = (counselorName) => {
    setSelectedCounselor(counselorName);
    setDoctorData2(false);
    setSearchQuery('');
    setSearchDefault({ page: '', search: '' });
    dispatch(searchAllCounselorDetail({ search: '' }));
    setValues((prevValues) => ({
      ...prevValues,
      counselorAssign: counselorName,
    }));
  };

  const selectProblem = (problemName) => {
    setSelectedProblem(problemName);
    setProblemData(false);
    setSearchQuery('');
    setSearchDefault({ page: '', search: '' });
    dispatch(allProblemSearchDetail('', '1'));
    setValues((prevValues) => ({
      ...prevValues,
      problem: problemName,
    }));
  };

  const convertToFormData = (values) => {
    const formData = new FormData();

    Object.keys(values).forEach((key) => {
      if (Array.isArray(values[key])) {
        formData.append(key, JSON.stringify(values[key]));
      }
      else if (typeof values[key] === 'object' && values[key] !== null) {
        if (key === 'campaign') {
          // Convert campaign object to JSON string
          formData.append(key, JSON.stringify(values[key]));
        } else {
          // For other objects like 'reference'
          Object.keys(values[key]).forEach(innerKey => {
            formData.append(`${key}.${innerKey}`, values[key][innerKey]);
          });
        }
      }
      else {
        formData.append(key, values[key]);
      }

      if (key === 'photo') {
        if (values[key]) {
          formData.append(key, values[key]);
        }
      }

    });

    return formData;
  };


  const handleAddLead = (values, { resetForm }) => {
    const formData = convertToFormData(values);

    dispatch(leadCreate(formData, limits, searchDefault1.status)).then(() => {
      toggle();
      resetForm();
    });
  };

  const searchData = (e) => {
    // const newSearchQuery = ;
    setSearchQuery(e.target.value);
    const newSearchParams = {
      ...searchDefault,
      search: searchQuery || '',
      page: mainPage,
    };
    setSearchDefault(newSearchParams);
    const queryParams = new URLSearchParams(newSearchParams).toString();
    // dispatch(searchAdmin(queryParams, newSearchParams.page));

    if (searchType === 'doctor') {
      dispatch(allDoctorSearchDetail(searchQuery))
    } else if (searchType === 'counselor') {
      dispatch(searchAllCounselorDetail(newSearchParams));
    }
    else if (searchType === 'problem') {
      dispatch(allProblemSearchDetail(searchQuery))
    }

    if (searchType === 'Doctor') {
      dispatch(allDoctorSearchDetail(searchQuery));
    } else if (searchType === 'Person') {
      dispatch(patientSearchData(searchQuery));
    }
  };

  useEffect(() => {
    // dispatch(getCounselor(limits));
    dispatch(getAdmin(limits));
    dispatch(allBranchDetail());
    dispatch(allProblemDetail());
    dispatch(allDoctorDetail())
    dispatch(allCounselorDetail())
    dispatch(patientData())
  }, []);
  const [leadStatuses, setLeadStatuses] = useState([]);

  // Add this useEffect to fetch lead statuses
    useEffect(() => {
      if (
        setting?.getSetting?.getSetting?.leadStatuses &&
        setting?.getSetting?.getSetting?.leadStatuses?.length > 0
      ) {
        setLeadStatuses(setting?.getSetting?.getSetting?.leadStatuses || []);
      }
    }, [setting]);

  // Add the getBackgroundColor function
  const getBackgroundColor = (leadStatusName) => {
    const status = leadStatuses.find(
      (status) => status.title.toLowerCase() === leadStatusName.toLowerCase(),
    );
    return status ? status.backgroundColor : 'transparent';
  };

  useEffect(() => {
    dispatch(getSetting())
  }, [])
  return (
    <Modal show={show} onHide={toggle} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Add Lead</Modal.Title>
      </Modal.Header>

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleAddLead}
      >
        {({ handleSubmit, setFieldValue, values, errors, handleChange }) => (
          <Form onSubmit={handleSubmit}>
            <Modal.Body>
              <div className="row">
                <div className="col-md-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Branch</Form.Label>
                    <Form.Select
                      placeholder="Select Branch"
                      className="shadow-none focus:!border-theme-dark"
                      name="branch"
                      onChange={(e) => setFieldValue('branch', e.target.value)}
                      value={values.branch}
                    >
                      <option value="" disabled selected>
                        Select Branch
                      </option>{' '}
                      {/* Default placeholder option */}
                      {createFile?.allBranch?.data?.Branches?.map((res) => {
                        return (
                          <option key={res._id} value={res.branchName}>
                            {res.branchName}
                          </option>
                        );
                      })}
                    </Form.Select>
                    <ErrorMessage
                      name="branch"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </div>
                <div className="col-md-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Phone Number</Form.Label>
                    <Form.Control
                      type="text"
                      name="phoneNumber"
                      as={Form.Control}
                      onChange={(e) =>
                        setFieldValue('phoneNumber', e.target.value)
                      }
                      value={values.phoneNumber}
                      placeholder="Enter Phone Number"
                      className="shadow-none focus:!border-theme-dark"
                    />
                    <ErrorMessage
                      name="phoneNumber"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </div>
                <div className="col-md-3">
                  <Form.Group className="mb-3">
                    <Form.Label>First Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="firstName"
                      as={Form.Control}
                      onChange={(e) =>
                        setFieldValue('firstName', e.target.value)
                      }
                      value={values.firstName}
                      placeholder="Enter First Name"
                      className="shadow-none focus:!border-theme-dark"
                    />
                    <ErrorMessage
                      name="firstName"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </div>
                <div className="col-md-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Middle Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="middleName"
                      as={Form.Control}
                      onChange={(e) =>
                        setFieldValue('middleName', e.target.value)
                      }
                      value={values.middleName}
                      placeholder="Enter Middle Name"
                      className="shadow-none focus:!border-theme-dark"
                    />
                    <ErrorMessage
                      name="middleName"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </div>
                <div className="col-md-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="lastName"
                      as={Form.Control}
                      onChange={(e) =>
                        setFieldValue('lastName', e.target.value)
                      }
                      value={values.lastName}
                      placeholder="Enter Last Name"
                      className="shadow-none focus:!border-theme-dark"
                    />
                    <ErrorMessage
                      name="lastName"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </div>

                <div className="col-md-3">
                  <Form.Group className="mb-3" controlId="Gender">
                    <Form.Label>Gender</Form.Label>
                    <Form.Select
                      placeholder="Select Gender"
                      className="shadow-none focus:!border-theme-dark"
                      name="gender"
                      onChange={(e) => setFieldValue('gender', e.target.value)}
                      value={values.gender}
                    >
                      <option value="" disabled selected>
                        Select Gender
                      </option>{' '}
                      {/* Default placeholder option */}
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Transander">Transander </option>
                    </Form.Select>
                    {/* <ErrorMessage
                      name="gender"
                      component="div"
                      className="text-danger"
                    /> */}
                  </Form.Group>
                </div>

                <div className="col-md-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Date of Birth</Form.Label>
                    <Form.Control
                      type="date"
                      name="dateOfBirth"
                      as={Form.Control}
                      onChange={(e) =>
                        setFieldValue('dateOfBirth', e.target.value)
                      }
                      value={values.dateOfBirth}
                      className="shadow-none focus:!border-theme-dark"
                    />
                    <ErrorMessage
                      name="dateOfBirth"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </div>
                <div className="col-md-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Country</Form.Label>
                    <Form.Control
                      type="text"
                      name="country"
                      as={Form.Control}
                      onChange={(e) => setFieldValue('country', e.target.value)}
                      value={values.country}
                      placeholder="Enter Country"
                      className="shadow-none focus:!border-theme-dark"
                    />
                    <ErrorMessage
                      name="country"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </div>
                <div className="col-md-3">
                  <Form.Group className="mb-3">
                    <Form.Label>State</Form.Label>
                    <Form.Control
                      type="text"
                      name="state"
                      as={Form.Control}
                      onChange={(e) => setFieldValue('state', e.target.value)}
                      value={values.state}
                      placeholder="Enter State"
                      className="shadow-none focus:!border-theme-dark"
                    />
                    <ErrorMessage
                      name="state"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </div>
                <div className="col-md-3">
                  <Form.Group className="mb-3">
                    <Form.Label>City</Form.Label>
                    <Form.Control
                      type="text"
                      name="city"
                      as={Form.Control}
                      onChange={(e) => setFieldValue('city', e.target.value)}
                      value={values.city}
                      placeholder="Enter City"
                      className="shadow-none focus:!border-theme-dark"
                    />
                    <ErrorMessage
                      name="city"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </div>
                <div className="col-md-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Area</Form.Label>
                    <Form.Control
                      type="text"
                      name="area"
                      as={Form.Control}
                      onChange={(e) => setFieldValue('area', e.target.value)}
                      value={values.area}
                      placeholder="Enter Area"
                      className="shadow-none focus:!border-theme-dark"
                    />
                    <ErrorMessage
                      name="area"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </div>
                <div className="col-md-3">
                  <Form.Group className="mb-3" controlId="leadReceived">
                    <Form.Label>Lead Received On</Form.Label>
                    <Form.Select
                      placeholder="Select Lead Received On"
                      className="shadow-none focus:!border-theme-dark"
                      name="leadReceived"
                      onChange={(e) =>
                        setFieldValue('leadReceived', e.target.value)
                      }
                      value={values.leadReceived}
                    >
                      <option value="" disabled selected>
                        Select Lead Received On
                      </option>{' '}
                      {/* Default placeholder option */}
                      <option value="justdialApp">Justdial app</option>
                      <option value="phone">Phone</option>
                      <option value="social">Social</option>
                      <option value="email">Email</option>
                      <option value="whatsapp">Whatsapp</option>
                    </Form.Select>{' '}
                    <ErrorMessage
                      name="leadReceived"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </div>

                <div className="col-md-3">
                  <Form.Group className="mb-3" controlId="categoryIssues">
                    <Form.Label>Consult </Form.Label>
                    <div className="relative">
                      <input
                        readOnly
                        placeholder="Select Consult"
                        className="border outline-none w-full border-theme-dark rounded py-[6px] px-[12px]"
                        name="problem"
                        onClick={() => {
                          setProblemData(!problemData);
                          setSearchType('problem')
                        }}
                        onChange={(e) =>
                          setFieldValue('problem', e.target.value)
                        }
                        value={values.problem}
                      />
                      {/* Default placeholder option */}
                      <div
                        className={`${problemData
                          ? 'opacity-100 visible'
                          : 'opacity-0 invisible'
                          } absolute w-full border top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}
                      >
                        <input
                          type="text"
                          name="search"
                          value={searchQuery}
                          placeholder={`Search Consult`}
                          onChange={searchData}
                          className="w-full border p-2 rounded outline-none"
                        />

                        {createFile?.allProblem?.data?.Problem?.map((res) => {
                          return (
                            <p
                              key={res._id}
                              onClick={() => {
                                selectProblem(res.problem);
                                setFieldValue('problem', res.problem);
                                setSearchQuery('')
                              }}
                              className="text-gray-700 py-1 cursor-pointer"
                            >
                              {res.problem}
                            </p>
                          );
                        })}
                      </div>
                    </div>
                    {/* <ErrorMessage
                      name="problem"
                      component="div"
                      className="text-danger"
                    /> */}
                  </Form.Group>
                </div>

                {/* <div className="col-md-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Lead Status</Form.Label>
                    <Form.Select
                      placeholder="Select Lead Status"
                      className="shadow-none focus:!border-theme-dark"
                      name="leadStatus"
                      onChange={(e) => setFieldValue('leadStatus', e.target.value)}
                      value={values.leadStatus}
                    >
                      <option value="" disabled selected>
                        Select Lead Status
                      </option>
                      {setting?.getSetting?.getSetting?.leadStatuses?.length > 0
                        ? setting.getSetting.getSetting.leadStatuses?.map((status) => (
                          <option key={status._id} value={status.title}>
                            {status.title}
                          </option>
                        ))
                        : null}
                    </Form.Select>
                    <ErrorMessage
                      name="leadStatus"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </div> */}
                <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Lead Status</Form.Label>
                <Form.Select
                  placeholder="Select Lead Status"
                  className="shadow-none focus:!border-theme-dark"
                  name="leadStatus"
                  onChange={(e) => setFieldValue('leadStatus', e.target.value)}
                  value={values.leadStatus}
                  style={{
                    backgroundColor:
                      values.leadStatus?.trim()
                        ? getBackgroundColor(values.leadStatus.trim().toLowerCase())
                        : '',
                    color: values.leadStatus?.trim() ? 'white' : 'black'
                  }}
                >
                  <option value="" disabled style={{
                    backgroundColor:"lightgray",
                    color:"white"
                  }}>
                    Select Lead Status
                  </option>
                  {setting?.getSetting?.getSetting?.leadStatuses?.length > 0
                    ? setting?.getSetting?.getSetting?.leadStatuses?.map((status) => (
                      <option key={status._id} value={status.title}
                      style={{
                        backgroundColor:"white",
                        color:"black"
                      }}>
                        {status.title}
                      </option>
                    ))
                    : null}
                </Form.Select>
                {/* <ErrorMessage name="leadStatus" component="div" className="text-danger" /> */}
              </Form.Group>
            </div>

                <div className="col-md-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Lead From</Form.Label>
                    <Form.Control
                      type="text"
                      name="area"
                      as={Form.Control}
                      onChange={(e) => setFieldValue('leadFrom', e.target.value)}
                      value={values.leadFrom}
                      placeholder="Enter Lead"
                      className="shadow-none focus:!border-theme-dark"
                    />
                  </Form.Group>
                </div>

                <div className="col-md-3">
                  <Form.Group className="mb-3" controlId="campaign">
                    <Form.Label>Campaign</Form.Label>
                    <Form.Select
                      className="shadow-none focus:!border-theme-dark"
                      name="campaign.cname"
                      onChange={(e) => {
                        setFieldValue('campaign.cname', e.target.value);
                      }}
                      value={values?.campaign?.cname}
                    >
                      <option value="" disabled selected>
                        Select Campaign
                      </option>
                      <option value="Walk-in">Walk-in</option>
                      <option value="Social">Social</option>
                      <option value="News">News</option>
                    </Form.Select>
                    <ErrorMessage
                      name="campaign.cname"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </div>

                {values?.campaign?.cname && (
                  <div className="col-md-3">
                    <Form.Group controlId="campaignDetail">
                      <Form.Label>{values?.campaign?.cname} Details</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder={`Enter ${values?.campaign?.cname} details`}
                        className="shadow-none"
                        name="campaign.description"
                        onChange={(e) =>
                          setFieldValue('campaign.description', e.target.value)
                        }
                        value={values?.campaign?.description}
                      />
                      <ErrorMessage
                        name="campaign.description"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                )}

                <div className="col-md-3">
                  <Form.Group className="mb-3" controlId="referance">
                    <Form.Label>Referance</Form.Label>
                    <Form.Select
                      className="shadow-none focus:!border-theme-dark"
                      name="selectedReference"
                      onChange={(e) => {
                        const { value } = e.target;
                        setSelectedOption('');
                        setFieldValue('selectedReference', value);
                        setFieldValue('personDetail', '');
                        setFieldValue('doctorDetail', '');
                      }}
                      value={values.selectedReference}
                    >
                      <option value="" disabled selected>
                        Select Referance
                      </option>{' '}
                      {/* Default placeholder option */}
                      <option value="Person">Person</option>
                      <option value="Doctor">Doctor</option>
                    </Form.Select>
                  </Form.Group>
                </div>

                {values?.selectedReference && (
                  <div className="col-md-3">
                    <Form.Group controlId="campaignDetail">
                      <Form.Label>
                        {values?.selectedReference} Details
                      </Form.Label>
                      <div className="relative" ref={dropdownRef}>
                        <div
                          className="border border-theme-dark rounded py-[6px] px-[12px]"
                          onClick={() => {
                            setDoctorData(!doctorData);
                            setSearchType(values?.selectedReference);
                          }}
                        >
                          {selectedOption
                            ? selectedOption
                            : `Select ${values?.selectedReference}`}
                        </div>
                        {values?.selectedReference === 'Doctor' && (
                          <div
                            className={`${doctorData
                              ? 'opacity-100 visible'
                              : 'opacity-0 invisible'
                              } absolute w-full border top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}
                          >
                            <input
                              type="text"
                              name="search"
                              value={searchQuery}
                              placeholder={`Search ${values?.selectedReference}..`}
                              onChange={searchData}
                              className="w-full border p-2 rounded outline-none"
                            />
                            {createFile?.allDoctor?.data?.doctor?.map((res) => (
                              <p
                                key={res._id}
                                value={res.name}
                                onClick={() => {
                                  setSelectedOption(res.name);
                                  setDoctorData(false);
                                  setSearchQuery('');
                                  setFieldValue('reference[0].doctorDetail', res.name);
                                  setFieldValue('doctorDetail', res.name);
                                  dispatch(allDoctorSearchDetail({ page: '', search: '' }))
                                }}
                                className="text-gray-700 py-1 cursor-pointer"
                              >
                                {res.name}
                              </p>
                            ))}
                          </div>
                        )}
                        {values?.selectedReference === 'Person' && (
                          <div
                            className={`${doctorData
                              ? 'opacity-100 visible'
                              : 'opacity-0 invisible'
                              } absolute w-full border top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}
                          >
                            <input
                              type="text"
                              placeholder={`Search ${values?.selectedReference}..`}
                              name="search"
                              value={searchQuery}
                              onChange={searchData}
                              className="w-full border p-2 rounded outline-none"
                            />
                            {createFile?.allPatient?.data?.PatientData?.map(
                              (res) => {
                                return (
                                  <p
                                    key={res._id}
                                    value={res.firstName + " " + res.lastName}
                                    onClick={() => {
                                      setSelectedOption(res.firstName + " " + res.lastName);
                                      setFieldValue('reference[0].personDetail', res.firstName + " " + res.lastName);
                                      setFieldValue('personDetail', res.firstName + " " + res.lastName);
                                      setSearchQuery('');
                                      setDoctorData(false);
                                      dispatch(patientSearchData({ page: '', search: '' }))
                                    }}
                                    className="text-gray-700 py-1 cursor-pointer"
                                  >
                                    {res.firstName + " " + res.lastName}
                                  </p>
                                );
                              },
                            )}
                          </div>
                        )}
                      </div>
                      <ErrorMessage
                        name={
                          values?.selectedReference === 'Doctor'
                            ? 'doctorDetail'
                            : 'personDetail'
                        }
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                )}

                {/* <div className="col-md-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Remark</Form.Label>
                    <Form.Control
                      type="text"
                      name="remark"
                      as={Form.Control}
                      onChange={(e) => setFieldValue('remark', e.target.value)}
                      value={values.remark}
                      placeholder="Enter Remark"
                      className="shadow-none focus:!border-theme-dark"
                    />
                    <ErrorMessage
                      name="remark"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </div> */}
                <div className="col-md-6">
                  <Form.Group className="mb-6">
                    <Form.Label>Remark</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={5}
                      cols={10}
                      name="remark"
                      onChange={(e) => setFieldValue('remark', e.target.value)}
                      value={values.remark}
                      placeholder="Enter Remark"
                      className="shadow-none focus:!border-theme-dark"
                    />
                    <ErrorMessage
                      name="remark"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </div>

                {/* <div className="col-md-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Referral</Form.Label>
                    <Form.Control
                      type="text"
                      name="referralCode"
                      as={Form.Control}
                      onChange={(e) => setFieldValue('referralCode', e.target.value)}
                      value={values.referralCode}
                      placeholder="Enter Referral"
                      className="shadow-none focus:!border-theme-dark"
                    />
                  </Form.Group>
                </div> */}

                <div className="border-t"></div>
                <h4 className="my-3">Call Time</h4>

                <div className="col-md-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Next Followup Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="nextFollowUpDate"
                      as={Form.Control}
                      onChange={(e) =>
                        setFieldValue('nextFollowUpDate', e.target.value)
                      }
                      value={values.nextFollowUpDate}
                      className="shadow-none focus:!border-theme-dark"
                    />
                    <ErrorMessage
                      name="nextFollowUpDate"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </div>
                <div className="col-md-3">
                  <Form.Group className="mb-3">
                    <Form.Label>From</Form.Label>
                    <Form.Control
                      type="time"
                      name="from"
                      onChange={(e) => setFieldValue('from', e.target.value)}
                      value={values.from}
                      // value={time.from ? time.from.split(' ')[0] : ''}
                      className="shadow-none focus:!border-theme-dark"
                    />{' '}
                    <ErrorMessage
                      name="from"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </div>
                <div className="col-md-3">
                  <Form.Group className="mb-3">
                    <Form.Label>To</Form.Label>
                    <Form.Control
                      type="time"
                      name="to"
                      onChange={(e) => setFieldValue('to', e.target.value)}
                      value={values.to}
                      // value={time.to ? time.to.split(' ')[0] : ''}
                      className="shadow-none focus:!border-theme-dark"
                    />
                    <ErrorMessage
                      name="to"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </div>

                <div className="col-md-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Nationality</Form.Label>
                    <Form.Control
                      type="text"
                      name="nationality"
                      as={Form.Control}
                      onChange={(e) =>
                        setFieldValue('nationality', e.target.value)
                      }
                      value={values.nationality}
                      placeholder="Enter Nationality"
                      className="shadow-none focus:!border-theme-dark"
                    />
                    <ErrorMessage
                      name="nationality"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </div>
                <div className="col-md-3">
                  <Form.Group controlId="campaignDetail">
                    <Form.Label>Doctor Name</Form.Label>
                    <div className="relative">
                      <input
                        name="doctorName"
                        value={values.doctorName}
                        placeholder={
                          selectedDoctor ? selectedDoctor : 'Select Doctor'
                        }
                        className="border w-full outline-none border-theme-dark rounded py-[6px] px-[12px]"
                        readOnly
                        onClick={() => {
                          setDoctorData1(!doctorData1);
                          setSearchType('doctor');
                        }}
                      />

                      <div
                        className={`${doctorData1
                          ? 'opacity-100 visible'
                          : 'opacity-0 invisible'
                          } absolute w-full border top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}
                      >
                        <input
                          type="text"
                          name="search"
                          value={searchQuery}
                          placeholder={`Search Doctors`}
                          onChange={searchData}
                          className="w-full border p-2 rounded outline-none"
                        />
                        {createFile?.allDoctor?.data?.doctor?.map((res) => (
                          <p
                            key={res._id}
                            onClick={() => {
                              selectDoctor(res.name, res.email);
                              setFieldValue('doctorName', res.name);
                              setFieldValue('doctorEmail', res.email);
                            }}
                            className="text-gray-700 py-1 cursor-pointer"
                          >
                            {res.name}
                          </p>
                        ))}
                      </div>
                    </div>
                    <ErrorMessage
                      name="doctorName"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </div>
                <div className="col-md-3">
                  <Form.Group className="mb-3">
                    <div className="">
                      <Form.Group className="mb-3">
                        <Form.Label>Counsellor assign</Form.Label>
                        <div className="relative">
                          <input
                            className="border w-full outline-none border-theme-dark rounded py-[6px] px-[12px]"
                            onClick={() => {
                              setDoctorData2(!doctorData2);
                              setSearchType('counselor');
                            }}
                            value={values.counselorAssign}
                            placeholder={selectedCounselor
                              ? selectedCounselor
                              : 'Select Counselor'}
                          />

                          <div
                            className={`${doctorData2
                              ? 'opacity-100 visible'
                              : 'opacity-0 invisible'
                              } absolute w-full border top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}
                          >
                            <input
                              type="text"
                              name="search"
                              value={searchQuery}
                              placeholder={`Search Counselors`}
                              onChange={searchData}
                              className="w-full border p-2 rounded outline-none"
                            />
                            {createFile?.allCounselor?.data?.CounselorsData?.map(
                              (res) => {
                                return (
                                  <p
                                    key={res._id}
                                    value={res.name}
                                    onClick={() => {
                                      selectCounselor(res.name);
                                      setFieldValue(
                                        'counselorAssign',
                                        res.name,
                                      );
                                    }}
                                    className="text-gray-700 py-1 cursor-pointer"
                                  >
                                    {res.name}
                                  </p>
                                );
                              },
                            )}
                          </div>
                        </div>
                      </Form.Group>
                    </div>
                    <ErrorMessage
                      name="counselorAssign"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </div>
                <div className="col-md-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Occupation</Form.Label>
                    <Form.Control
                      type="text"
                      name="occupation"
                      as={Form.Control}
                      onChange={(e) =>
                        setFieldValue('occupation', e.target.value)
                      }
                      value={values.occupation}
                      placeholder="Enter Occupation"
                      className="shadow-none focus:!border-theme-dark"
                    />
                    <ErrorMessage
                      name="occupation"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </div>

                <div className="col-md-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="text"
                      name="email"
                      as={Form.Control}
                      onChange={(e) => setFieldValue('email', e.target.value)}
                      value={values.email}
                      placeholder="Enter Email"
                      className="shadow-none focus:!border-theme-dark"
                    />
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </div>
                <div className="col-md-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Address</Form.Label>
                    <Form.Control
                      type="text"
                      name="address"
                      as={Form.Control}
                      onChange={(e) => setFieldValue('address', e.target.value)}
                      value={values.address}
                      placeholder="Enter Address"
                      className="shadow-none focus:!border-theme-dark"
                    />
                    <ErrorMessage
                      name="address"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </div>
                <div className="col-md-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Blood Group</Form.Label>
                    <Form.Control
                      type="text"
                      name="bloodGroup"
                      as={Form.Control}
                      onChange={(e) =>
                        setFieldValue('bloodGroup', e.target.value)
                      }
                      value={values.bloodGroup}
                      placeholder="Enter Blood Group"
                      className="shadow-none focus:!border-theme-dark"
                    />
                    <ErrorMessage
                      name="bloodGroup"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </div>
                <div className="col-md-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Pincode</Form.Label>
                    <Form.Control
                      type="text"
                      name="pincode"
                      as={Form.Control}
                      onChange={(e) => setFieldValue('pincode', e.target.value)}
                      value={values.pincode}
                      placeholder="Enter Pincode"
                      className="shadow-none focus:!border-theme-dark"
                    />
                    <ErrorMessage
                      name="pincode"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </div>

                <div className="col-md-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Lead FollowUp Remark</Form.Label>
                    <Form.Control
                      type="text"
                      name="leadFollowUpRemark"
                      as={Form.Control}
                      onChange={(e) =>
                        setFieldValue('leadFollowUpRemark', e.target.value)
                      }
                      value={values.leadFollowUpRemark}
                      placeholder="Select Lead FollowUp Remark"
                      className="shadow-none focus:!border-theme-dark"
                    />
                    <ErrorMessage
                      name="leadFollowUpRemark"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </div>
                <div className="col-md-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Photo</Form.Label>
                    <Form.Control
                      type="file"
                      name="photo"
                      onChange={(event) => {
                        const file = event.currentTarget.files[0];
                        setFieldValue("photo", file);
                      }}
                      className="shadow-none focus:!border-theme-dark"
                    />
                  </Form.Group>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={toggle}
                className="px-4 bg-transparent border-[1px] text-black border-green-color"
              >
                Close
              </Button>
              <Button
                type="submit"
                // onClick={handleAddLead}
                className="!bg-theme-dark border-0 px-4"
              >
                Save
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default CreateModal;
